import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaGraduationCap, FaUserNurse, FaBriefcaseMedical } from "react-icons/fa";

const Pricing = () => {
  const plans = [
    {
      title: "Öğrenci",
      price: "1499₺ / yıl",
      icon: <FaGraduationCap size={36} color="#2D8A7A" />,
      features: [
        "Tüm formül veri tabanına ve özelliklere erişim",
        "%25 Öğrenci Özel İndirimi",
        "Eczacılık ve Tıp Fakülteleri Öğrencileri"
      ],
      kdv: "Faturanız ödemeden sonra iletilecektir.",
    },
    {
      title: "Eczacı, Hekim ve Akademisyen",
      price: "1999₺ / yıl",
      icon: <FaBriefcaseMedical size={36} color="#2D8A7A" />,
      features: [
        "Tüm formül veri tabanına ve özelliklere erişim",
      ],
      kdv: "Faturanız ödemeden sonra iletilecektir.",
    },
  ];

  return (
    <section
      id="pricing"
      className="position-relative py-5"
      // BURADA SADECE RENK KALDI, OVERFLOW'U SİLDİK ÇÜNKÜ SCSS HALLEDİYOR
      style={{
        background: "linear-gradient(180deg, #FFFFFF 0%, #E7F5F2 100%)",
      }}
    >
      {/* Glow efekt */}
      <div
        className="position-absolute top-0 end-0 opacity-50"
        style={{
          width: "700px",
          height: "700px",
          background: "radial-gradient(circle, #7DD1C0 0%, transparent 70%)",
          filter: "blur(100px)",
          zIndex: 0,
        }}
      ></div>

      <Container style={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-center mb-5"
        >
          <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
            Üyelik Paketleri
          </h2>
          <p className="text-muted lead">
            Sizin için uygun olan planı seçin ve Majistral App’in tüm özelliklerinden faydalanın.
          </p>
        </motion.div>

        <Row className="g-4 justify-content-center">
          {plans.map((plan, index) => (
            <Col md={4} sm={6} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2, duration: 0.6 }}
              >
                <Card className="pricing-card text-center shadow-sm border-0 p-4 h-100">
                  <div className="mb-3">{plan.icon}</div>
                  <h4 className="fw-bold" style={{ color: "#2D8A7A" }}>
                    {plan.title}
                  </h4>
                  <h5 className="text-muted mb-4">{plan.price}</h5>
                  <ul className="list-unstyled mb-4 text-start">
                    {plan.features.map((f, i) => (
                      <li key={i} className="mb-2">
                        ✅ {f}
                      </li>
                    ))}
                  </ul>

                  <div
                    className="bg-light rounded p-3 mb-3"
                    style={{
                      fontSize: "0.9rem",
                      color: "#2D8A7A",
                      wordBreak: "break-all",
                    }}
                  >
                    <strong>KDV Dahildir.</strong>
                    <br />
                    {plan.kdv}
                  </div>

                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100"
                    style={{
                      backgroundColor: "#2D8A7A",
                      borderColor: "#2D8A7A",
                    }}
                    href="/register"
                  >
                    Üye Ol
                  </Button>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>

        <div className="text-center mt-5">
          <p className="text-muted small">
            💡 Toplu alımlarda çeşitli avantajları yakalamak için bizimle iletişime geçebilirsiniz.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Pricing;